module.exports = __webpack_public_path__ + "static/img/iron.358eece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/leagueoflegends/ranks/iron.png
// module id = C6go
// module chunks = 35